<template>
  <div class="relative w-dvw h-dvh">
    <CircleBarSpinner
      v-if="!loaded"
      class="text-gray-400 absolute z-[9999999] left-[47%] top-[47%]"
    />
    <div v-show="loaded" class="w-full h-full" id="panzoom-container">
      <img
        :src="item.src"
        @load="onImageServerLoad"
        @error="onImageError"
        id="zoom-target"
        class="w-auto h-auto max-w-full max-h-full p-4 duration-300 md:p-10"
      />
    </div>

    <button
      class="absolute flex items-center justify-center w-8 h-8 bg-black rounded-sm shadow-md bg-opacity-30 bottom-7 right-14"
      id="zoom-in"
    >
      <SearchIcon class="w-6 h-6 text-white" />
    </button>
    <button
      class="absolute flex items-center justify-center w-8 h-8 bg-black rounded-sm shadow-md bottom-7 right-4 bg-opacity-30"
      id="zoom-out"
    >
      <MinusIcon class="w-6 h-6 text-white" />
    </button>
  </div>
</template>
<script setup>
import panzoom from "panzoom";
const SearchIcon = defineAsyncComponent(() =>
  import("~/assets/svg/heroicons/search.svg?component")
);
const MinusIcon = defineAsyncComponent(() =>
  import("@/assets/svg/heroicons/search-minus.svg?component")
);
const props = defineProps({
  item: Object,
  close: {
    type: Function,
    default: null,
  },
});

const loaded = ref(false);
const error = ref(false);
let panZoomInstance = null;

watch(
  () => props.item,
  (newValue) => {
    loaded.value = false;
    if (panZoomInstance) {
      const clrt = setTimeout(() => {
        onImageLoad();
        clearTimeout(clrt);
      }, 350);
    }
  },
  { deep: true }
);

onMounted(() => {
  const element = document.getElementById("zoom-target");

  // Wait for image to load
  element.onload = () => {
    panZoomInstance = panzoom(element, {
      initialZoom: 1,
      minZoom: 0.5,
      maxZoom: 9,
      zoomSpeed: 0.5,
      smoothScroll: false,
      pinchSpeed: 1.7,
    });

    onImageLoad();
  };

  // Zoom In Button
  document.getElementById("zoom-in").addEventListener("click", () => {
    panZoomInstance.zoomTo(0, 0, 1.2);
  });

  // Zoom Out Button
  document.getElementById("zoom-out").addEventListener("click", () => {
    panZoomInstance.zoomTo(0, 0, 0.8);
  });
});

function onImageLoad() {
  const container = document.getElementById("panzoom-container");
  const element = document.getElementById("zoom-target");

  const imgRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  // Calculate center offset
  const offsetY = (containerRect.height - imgRect.height) / 2;

  // Move the image to the center
  panZoomInstance.moveTo(0, offsetY);
}

onBeforeUnmount(() => {
  const element = document.getElementById("zoom-target");
  if (element.onload) {
    element.onload = null;
  }
  if (panZoomInstance) {
    panZoomInstance.dispose();
  }
});

const onImageServerLoad = () => {
  loaded.value = true;
  error.value = false;
};

const onImageError = () => {
  error.value = true;
  loaded.value = false;
};
</script>
<style scoped>
.xx-drag-zoom {
  position: absolute;
  user-select: none;
}
.xx-drag-zoom img {
  cursor: grab;
}
.xx-drag-zoom img {
  @apply !h-[95dvh] !w-[97dvw] object-contain rounded-[5px];
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
